import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import pageAssets from '../../../../data/pageAssets';
import AppImage from '../../../common/media/AppImage';
import { openQuoteChat } from '../../../../utils/site';
import { getOrbitStarPage } from '../../../../data/db';
import OrbitStarVariantsModal from '../../lights/components/OrbitStarVariantsModal';

const HomeFestiveBanner = ({ banner }) => {
    const [isVariantsOpen, setVariantsOpen] = useState(false);
    const closeVariants = useCallback(() => setVariantsOpen(false), []);
    const variantsSection = getOrbitStarPage()?.variantsSection;

    return (
        <section className="home-festive-banner">
            <Link
                to={banner.route}
                className="home-festive-banner-link"
                aria-label={banner.linkLabel}
                style={{
                    '--banner-bg': `url(${pageAssets[banner.webpImageKey || banner.imageKey]})`,
                    '--banner-bg-mobile': `url(${pageAssets[banner.mobileWebpImageKey || banner.mobileImageKey || banner.imageKey]})`
                }}
            >
                <picture>
                    {banner.mobileWebpImageKey ? (
                        <source media="(max-width: 768px)" type="image/webp" srcSet={pageAssets[banner.mobileWebpImageKey]} width="1214" height="1295" />
                    ) : null}
                    {banner.mobileImageKey ? (
                        <source media="(max-width: 768px)" srcSet={pageAssets[banner.mobileImageKey]} width="1214" height="1295" />
                    ) : null}
                    {banner.webpImageKey ? (
                        <source type="image/webp" srcSet={pageAssets[banner.webpImageKey]} width="1774" height="887" />
                    ) : null}
                    <AppImage src={pageAssets[banner.imageKey]} alt={banner.imageAlt} priority width="1774" height="887" />
                </picture>
            </Link>
            <div className="home-festive-bar">
                <div className="container home-festive-bar-inner">
                    <div className="home-festive-bar-text">
                        <span className="home-festive-bar-eyebrow">{banner.eyebrow}</span>
                        <strong>{banner.title}</strong>
                        <span className="home-festive-bar-subtitle">{banner.subtitle}</span>
                    </div>
                    <div className="home-festive-bar-actions">
                        {variantsSection ? (
                            <button
                                type="button"
                                className="btn btn-primary home-festive-bar-variants"
                                onClick={() => setVariantsOpen(true)}
                            >
                                <span className="home-festive-bar-swatches" aria-hidden="true">
                                    {variantsSection.models[0].items.map((item) => (
                                        <span key={item.colour} style={{ background: item.swatch }} />
                                    ))}
                                </span>
                                {banner.variantsCtaLabel}
                            </button>
                        ) : null}
                        <Link to={banner.route} className="btn home-festive-bar-ghost">{banner.primaryCtaLabel}</Link>
                        <button type="button" className="btn home-festive-bar-ghost" onClick={openQuoteChat}>{banner.secondaryCtaLabel}</button>
                    </div>
                </div>
            </div>
            {variantsSection ? (
                <OrbitStarVariantsModal section={variantsSection} isOpen={isVariantsOpen} onClose={closeVariants} source="home_banner" />
            ) : null}
        </section>
    );
};

export default HomeFestiveBanner;
